"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mendMarkdown = void 0;
/**
 * 修复 markdown 格式缺失问题
 * @param md - 需要修复的 markdown 字符串
 * @returns string 修复后的 markdown 字符串
 */
const mendMarkdown = (md) => {
    const mendCode = md
        .replace(/(?<!\n)```/g, '\n```')
        .replace(/```([a-zA-Z]*)([\s\S]*?)```/g, function (_, language, codeContent) {
        const trimmedCode = codeContent.trim();
        return '\n```' + language + '\n' + trimmedCode + '\n```\n';
    });
    const lines = mendCode.split('\n');
    const mendTitle = lines
        .map((line) => {
        const match = line.match(/^(\s*)(#+)(\s*)(.*)$/);
        if (match) {
            const [, leadingSpaces, hashes, spaces, content] = match;
            if (hashes.length > 0 &&
                spaces.length === 0 &&
                !content.startsWith('#')) {
                return `${leadingSpaces}${hashes} ${content}`;
            }
        }
        return line;
    })
        .join('\n');
    return mendTitle.trim();
};
exports.mendMarkdown = mendMarkdown;
//# sourceMappingURL=mendMarkdown.js.map